import React, { Component } from "react";
import PropTypes from "prop-types";
import { Card, CardHeader, CardText } from "material-ui/Card";
import Avatar from "material-ui/Avatar";
import { IconVariant } from "../../components/mui/icon";
import ImageVariantByColor from "../../components/image/ImageVariantByColor";
import ImageVariantByAll from "../../components/image/ImageVariantByAll";
import { isEqual } from "../utils";
import lomap from "lodash/map";
import zipObject from "lodash/zipObject";
import { BoxMessage } from "../styled";
import { toLower } from "lodash";

const defaultAllImage = { "*": { photos: [] } };
const defaultColorImage = { code: "#FFFFFF", photos: [] };

class EditImageByVariant extends Component {
  constructor(props) {
    super(props);
    const isByColor =
      props.variant.options.filter((item) => toLower(item.name) === "color")
        .length > 0;
    const dataPhotoAll = !isByColor
      ? this.checkPhotosAllRecord()
      : defaultAllImage;
    const dataPhotoColors = isByColor ? this.checkPhotosColorRecord() : {};
    this.state = {
      expandedImage: true,
      variant: props.variant,
      photosAll: dataPhotoAll,
      photoSet: dataPhotoColors,
      isByColor: isByColor,
    };
  }

  componentDidMount() {
    if (this.state.isByColor) {
      this.onUpdatePhotos();
    } else {
      this.onUpdatePhotosAll();
    }
  }

  checkPhotosAllRecord() {
    const { photos } = this.props;
    let updateData = defaultAllImage;
    if (photos && photos !== null) {
      if (Array.isArray(photos)) {
        updateData = { "*": { photos } };
      } else {
        updateData = photos;
      }
    }
    return updateData;
  }

  checkPhotosColorRecord() {
    const { photos, variant } = this.props;
    let updateData = {};
    if (photos && photos !== null) {
      if (Array.isArray(photos)) {
        const optionsColor = variant.options.filter(
          (item) =>
            item.name &&
            toLower(item.name) === "color" &&
            item.values &&
            item.values.length > 0
        );
        if (optionsColor.length > 0) {
          const data = zipObject(
            optionsColor[0].values,
            lomap(optionsColor[0].values, (item, index) => {
              return { code: "#FFFFFF", photos: photos };
            })
          );
          return data;
        }
      } else if (photos["*"] && photos["*"].photos) {
        const optionsColor = variant.options.filter(
          (item) =>
            item.name &&
            toLower(item.name) === "color" &&
            item.values &&
            item.values.length > 0
        );
        if (optionsColor.length > 0) {
          const data = zipObject(
            optionsColor[0].values,
            lomap(optionsColor[0].values, (item, index) => {
              return { code: "#FFFFFF", photos: photos["*"].photos };
            })
          );
          return data;
        }
      } else {
        const optionsColor = variant.options.filter(
          (item) =>
            item.name &&
            toLower(item.name) === "color" &&
            item.values &&
            item.values.length > 0
        );
        if (photos["photo_set"]) {
          if (optionsColor.length > 0) {
            const valueColor = optionsColor[0].values[0];
            if (photos["photo_set"][valueColor]) {
              updateData = photos["photo_set"];
            } else {
              const data = zipObject(
                optionsColor[0].values,
                lomap(optionsColor[0].values, (item, index) => {
                  return { code: "#FFFFFF", photos: [] };
                })
              );
              updateData = data;
            }
          } else {
            const data = zipObject(
              optionsColor[0].values,
              lomap(optionsColor[0].values, (item, index) => {
                return { code: "#FFFFFF", photos: [] };
              })
            );
            updateData = data;
          }
        } else {
          if (optionsColor.length > 0) {
            const data = zipObject(
              optionsColor[0].values,
              lomap(optionsColor[0].values, (item, index) => {
                return { code: "#FFFFFF", photos: [] };
              })
            );
            updateData = data;
          }
        }
      }
    }

    return updateData;
  }

  handleExpandChange = (expanded) => {
    this.setState({ expandedImage: expanded });
  };

  componentWillReceiveProps(nextProps) {
    const { photoSet, photosAll, isByColor } = this.state;
    if (!isEqual(this.state.variant, nextProps.variant)) {
      if (isByColor) {
        const optionsColor = nextProps.variant.options.filter(
          (item) =>
            item.name &&
            toLower(item.name) === "color" &&
            item.values &&
            item.values.length > 0
        );
        if (optionsColor.length > 0) {
          const data = zipObject(
            optionsColor[0].values,
            lomap(optionsColor[0].values, (item, index) => {
              for (const p in photoSet) {
                if (p === item) {
                  return photoSet[p];
                }
              }
              return defaultColorImage;
            })
          );
          this.setState({
            photoSet: data,
          });
          let updateData = {};
          updateData.photo_set = data;
          this.props.onUpdatePhotos(updateData);
        }
      } else {
        this.props.onUpdatePhotos(photosAll);
      }
      this.setState({
        variant: nextProps.variant,
        isByColor,
      });
    }
  }

  onUpdatePhotos = () => {
    let data = {};
    data.photo_set = this.state.photoSet;
    this.props.onUpdatePhotos(data);
  };

  onUpdatePhotosAll = () => {
    this.props.onUpdatePhotos(this.state.photosAll);
  };

  renderImageBox() {
    const { photosAll } = this.state;
    const { nameProduct, tagsProduct } = this.props;
    return (
      <div>
        <ImageVariantByAll
          dataImage={photosAll["*"]}
          nameProduct={nameProduct}
          tagsProduct={tagsProduct}
          onUpdatePhotos={this.onUpdatePhotosAll.bind(this)}
          accept='image/*'
        />
      </div>
    );
  }

  renderImageByColorBox() {
    const { photoSet, variant } = this.state;
    const { nameProduct, tagsProduct } = this.props;
    if (variant.options) {
      const optionsColor = variant.options.filter(
        (item) =>
          item.name &&
          toLower(item.name) === "color" &&
          item.values &&
          item.values.length > 0
      );

      if (optionsColor.length > 0) {
        return (
          <div>
            <div>Please upload Product image for each Color</div>
            {optionsColor[0].values.map((item, index) => (
              <div key={item}>
                <ImageVariantByColor
                  keyObject={item}
                  dataImage={photoSet[item]}
                  nameProduct={nameProduct}
                  tagsProduct={tagsProduct}
                  onUpdatePhotos={this.onUpdatePhotos.bind(this)}
                  accept='image/*'
                />
              </div>
            ))}
          </div>
        );
      }
    }
    return null;
  }
  render() {
    const { isByColor } = this.state;
    return (
      <div>
        <Card
          expanded={this.state.expandedImage}
          onExpandChange={this.handleExpandChange}
          style={{ marginBottom: 16 }}
        >
          <CardHeader
            title='Images'
            subtitle={
              <BoxMessage>
                Important: Please complete Variant information first before
                upload product image.
              </BoxMessage>
            }
            avatar={<Avatar icon={<IconVariant />} />}
            actAsExpander={true}
            showExpandableButton={true}
          />
          <CardText expandable={true}>
            <div>
              {isByColor ? this.renderImageByColorBox() : this.renderImageBox()}
            </div>
          </CardText>
        </Card>
      </div>
    );
  }
}

EditImageByVariant.propTypes = {
  variant: PropTypes.object,
  nameProduct: PropTypes.string.isRequired,
  tagsProduct: PropTypes.array,
  onUpdatePhotos: PropTypes.func.isRequired,
  photos: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

EditImageByVariant.defaultProps = {
  tagsProduct: [],
};

export default EditImageByVariant;



// WEBPACK FOOTER //
// ./src/products/edit/EditImageByVariant.js